import { createFileRoute } from '@tanstack/react-router';
import { attentionSearchSchema } from '@/features/shipments/attention';
import { AttentionPage } from '@/features/shipments/attention-page';

// S01a · Needs attention (07 §3): the grouping lives in the URL.
export const Route = createFileRoute('/_app/shipments/attention')({
  validateSearch: attentionSearchSchema,
  component: AttentionPage,
});
